@import '../../../theme.scss';

verdocs-template-attachments {
  font-family: $verdocs-primary-font;

  h5 {
    font-size: 16px;
    font-weight: bold;
    margin: 0 0 10px 0;
    color: $verdocs-grey-blue;
  }

  .attachments {
    margin: 0 0 40px 0;
  }

  .attachment {
    display: flex;
    padding: 5px 0;
    column-gap: 15px;
    align-items: center;
    flex-direction: row;
    color: $label-color;

    &:hover {
      .trash-icon {
        display: flex;
      }

      .pages {
        display: none;
      }
    }
  }

  svg {
    width: 28px;
    height: 28px;
    fill: $verdocs-bg-4;
    margin: 2px 0 0 0;
  }

  .file-icon {
    flex: 0;
  }

  .pages {
    width: 24px;
    height: 24px;
    flex: 0 0 24px;
    padding-left: 4px;
    position: relative;
    margin: -10px 0 0 0;

    .pages-icon {
      top: 0;
      left: 0;
      width: 24px;
      height: 24px;
      position: absolute;
    }

    .count {
      top: 11px;
      left: 7px;
      z-index: 1;
      width: 18px;
      font-size: 12px;
      font-weight: 500;
      position: absolute;
      text-align: center;
      letter-spacing: -2px;
    }
  }

  .filename {
    flex: 1;
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    border-bottom: 1px dotted #cccccc;
  }

  .trash-icon {
    flex: 0;
    display: none;

    &:hover {
      cursor: pointer;
    }
  }

  verdocs-file-chooser {
    margin: 10px 0;
    border: 2px dashed #979797;
  }

  .loader-wrapper {
    background-color: $verdocs-grey-4;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    position: relative;
    width: 320px;
    height: 320px;
    text-align: center;
    border: 2px dashed #979797;
    justify-content: flex-end;
  }

  .progress-wrapper {
    padding: 20px;
  }

  .buttons {
    display: flex;
    column-gap: 8px;
    margin-top: 16px;
    align-items: center;
    flex-direction: row;
    justify-content: flex-end;

    .flex-fill {
      flex: 1;
    }
  }

  ::placeholder {
    color: $verdocs-bg-2;
  }
}
